module.exports = __webpack_public_path__ + "static/media/24UHCHR26.9e8c4c7d.jpg";